import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import { useNavigate } from "react-router";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../../customHooks/useGetHook";
const CreateUserComponent = loadable(
  () => import("../../components/Merchant User/MerchantCreateUser")
);
const MerchantCreateUser = () => {
  const naivate = useNavigate();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["users"],
    navigateURL: "/users",
  });
  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.USER}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
      // if(res.status==201){
      //   naivate(`/users/edit/${res?.data?.id}`)
      // }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create User
        </span>
      </div>
      <CreateUserComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default MerchantCreateUser;
